import { render, staticRenderFns } from "./ChecksReview.vue?vue&type=template&id=a880be2a&scoped=true&"
import script from "./ChecksReview.vue?vue&type=script&lang=ts&"
export * from "./ChecksReview.vue?vue&type=script&lang=ts&"
import style0 from "./ChecksReview.vue?vue&type=style&index=0&id=a880be2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a880be2a",
  null
  
)

export default component.exports